import { Container, DoubleSidedImage } from "components/shared";
import Table from "components/ui/Table";

const { Tr, Td, TBody } = Table;

const DataNotFound = (props) => {
  const { columns = 1 } = props;
  return (
    <TBody>
      <Tr>
        <Td colSpan={columns}>
          <Container className="h-full w-full py-4">
            <div className="h-full flex flex-col items-center justify-center">
              <DoubleSidedImage
                src="/img/others/img-2.png"
                darkModeSrc="/img/others/img-2-dark.png"
                alt="Access Denied!"
              />
              <div className="mt-6 text-center">
                <h3 className="mb-2">Data not found!</h3>
                <p className="text-base">You have no data to visit this page</p>
              </div>
            </div>
          </Container>
        </Td>
      </Tr>
    </TBody>
  );
};

export default DataNotFound;
